import register from 'preact-custom-element'
import { AccountWishlistPDP } from '@/components/libs/omneo/components/AccountWishlistPDP'

register(AccountWishlistPDP, 'x-omneo-wishlist')
